__turbopack_context__.v({
  "button": "fileUploadField-module-scss-module__0EWtyG__button",
  "container": "fileUploadField-module-scss-module__0EWtyG__container",
  "dropzone": "fileUploadField-module-scss-module__0EWtyG__dropzone",
  "dropzone-error": "fileUploadField-module-scss-module__0EWtyG__dropzone-error",
  "dropzone-hint": "fileUploadField-module-scss-module__0EWtyG__dropzone-hint",
  "dropzone-hint-disabled": "fileUploadField-module-scss-module__0EWtyG__dropzone-hint-disabled",
  "dropzone-text": "fileUploadField-module-scss-module__0EWtyG__dropzone-text",
  "dropzone-text-disabled": "fileUploadField-module-scss-module__0EWtyG__dropzone-text-disabled",
  "error-msg": "fileUploadField-module-scss-module__0EWtyG__error-msg",
  "errorContainer": "fileUploadField-module-scss-module__0EWtyG__errorContainer",
  "errorContent": "fileUploadField-module-scss-module__0EWtyG__errorContent",
  "errorIcon": "fileUploadField-module-scss-module__0EWtyG__errorIcon",
  "hint": "fileUploadField-module-scss-module__0EWtyG__hint",
  "textContainer": "fileUploadField-module-scss-module__0EWtyG__textContainer",
  "upload-icon": "fileUploadField-module-scss-module__0EWtyG__upload-icon",
  "upload-icon-wrapper": "fileUploadField-module-scss-module__0EWtyG__upload-icon-wrapper",
  "upload-icon-wrapper-error": "fileUploadField-module-scss-module__0EWtyG__upload-icon-wrapper-error",
  "upload-icon-wrapper-hover": "fileUploadField-module-scss-module__0EWtyG__upload-icon-wrapper-hover",
});
